import { Subject } from "@biblioteksentralen/cordata";
import { Box, Heading, List, SimpleGrid } from "@biblioteksentralen/react";
import { useSubjectUrlPagination } from "../../app/[locale]/sites/[siteDomain]/samling/emner/[id]/page.client";
import { WorksData } from "../../app/[locale]/sites/[siteDomain]/samling/personer/[agentBibbiIdAndNorafId]/fetchAgentWorksData";
import { DefaultContainer } from "../../components/ContentContainer";
import { useTranslation } from "../../utils/hooks/useTranslation";
import { SeeMoreResultsButton } from "./search/SeeMoreResultsButton";
import WorkPreview from "./works/WorkPreview";
import { useState } from "react";

type SubjectViewProps = {
  subject?: Subject;
  worksData: WorksData;
};

export const SubjectView = ({ subject, worksData }: SubjectViewProps) => {
  const { t, ts } = useTranslation();

  const { paginate } = useSubjectUrlPagination();

  const [autoFocusIndex, setAutoFocusIndex] = useState<number | undefined>(undefined);

  const paginateAndFocus = () => {
    //sets focus on first item of next pagination
    setAutoFocusIndex(works.length);
    paginate();
  };

  const { works, endOfResults, isValidating } = worksData;

  return (
    <DefaultContainer margin="1rem auto 3rem" padding="0">
      <Box padding="1rem 2rem">
        <Heading as="h1" size="lg" marginBottom=".5rem">
          {t("Materialer om {emneNavn}", { emneNavn: ts(subject?.name)?.toLowerCase() })}
        </Heading>
        <SimpleGrid as={List} spacing="2rem" columns={{ base: 1, lg: 2, xl: 3 }}>
          {works?.map((work, index) => {
            return <WorkPreview key={work.id} work={work} headingSize="h2" autoFocus={index == autoFocusIndex} />;
          })}
        </SimpleGrid>
        {!endOfResults && <SeeMoreResultsButton marginTop="4rem" loading={isValidating} onClick={paginateAndFocus} />}
      </Box>
    </DefaultContainer>
  );
};
